export default class {
	constructor() {
		this.modal = '.js-customer-modal';
		this.modalTrigger = '.js-customer-modal-trigger';
		this.modalContents = '.js-customer-modal-contents';
		this.bg = '.js-customer-modal-bg';
		this.close = '.js-customer-modal-close';
		this.class = 'is-active';

		this.navModal = '.js-customer-nav-modal';
		this.navModalTrigger = '.js-customer-nav-modal-trigger';
		this.navModalContents = '.js-customer-nav-modal-contents';
		this.navBg = '.js-customer-nav-modal-bg';
		this.navClose = '.js-customer-nav-modal-close';

		this.init();
		this.customerNav();
	}

	init() {
		const triggerAry = document.querySelectorAll(this.modalTrigger);
		const contentsAry = document.querySelectorAll(this.modalContents);
		const modal = document.querySelector(this.modal);
		const close = document.querySelector(this.close);
		const bg = document.querySelector(this.bg);

		const closeAction = () => {
			modal.classList.remove(this.class);
			for (let i = 0; i < triggerAry.length; i++) {
				triggerAry[i].classList.remove(this.class);
				contentsAry[i].classList.remove(this.class);
			}
		}

		if (modal) {
			triggerAry.forEach((element, index) => {
				element.addEventListener('click', () => {
					modal.classList.add(this.class);
					for (let i = 0; i < contentsAry.length; i++) {
						contentsAry[i].classList.remove(this.class);

					}
					contentsAry[index].classList.add(this.class);
				})
			});

			close.addEventListener('click', closeAction);
			bg.addEventListener('click', closeAction);
		}
	}
	customerNav() {
		const navTriggerAry = document.querySelectorAll(this.navModalTrigger);
		const navContentsAry = document.querySelectorAll(this.navModalContents);
		const navModal = document.querySelector(this.navModal);
		const navClose = document.querySelector(this.navClose);
		const navBg = document.querySelector(this.navBg);

		const closeAction = () => {
			navModal.classList.remove(this.class);
			for (let i = 0; i < navTriggerAry.length; i++) {
				navTriggerAry[i].classList.remove(this.class);
				navContentsAry[i].classList.remove(this.class);
			}
		}

		if (navModal) {
			navTriggerAry.forEach((element, index) => {
				element.addEventListener('click', () => {
					navModal.classList.add(this.class);
					for (let i = 0; i < navContentsAry.length; i++) {
						navContentsAry[i].classList.remove(this.class);

					}
					navContentsAry[index].classList.add(this.class);
				})
			});

			navClose.addEventListener('click', closeAction);
			navBg.addEventListener('click', closeAction);
		}
	}
}